import { render, staticRenderFns } from "./card-product.vue?vue&type=template&id=2c7a535f"
import script from "./card-product.vue?vue&type=script&lang=js"
export * from "./card-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports